<template>
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M43.75 25C43.75 35.3554 35.3554 43.75 25 43.75C14.6447 43.75 6.25 35.3554 6.25 25C6.25 14.6447 14.6447 6.25 25 6.25C35.3554 6.25 43.75 14.6447 43.75 25Z" stroke="#0787C9" stroke-width="4.16667" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M25 16.6667V27.0834" stroke="#0787C9" stroke-width="4.16667" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M25 33.3333V33.3099" stroke="#0787C9" stroke-width="4.16667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
